import React from 'react';
import last from 'lodash.last';
import PropTypes from 'prop-types';
import {
    reformatItemLevelDetails,
    isRowSkipped,
    notIncludedInScore,
    reformatParagraphs,
} from '../../../../utils/shared/probeDetailUtils';
import OralReadingWord from './OralReadingWord';
import SkippedRow from './SkippedRow';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const OralReadingContent = ({ itemLevelDetails, paragraphs, selfCorrectedMark }) => {
    const { skippedRows, selfCorrectedItems, incorrectItems, lastSelectedItem } =
        reformatItemLevelDetails(itemLevelDetails);

    const readWords = [];
    const notReadWords = [];

    reformatParagraphs(paragraphs).forEach(paragraph => {
        paragraph.forEach(({ row, index }) => {
            if (isRowSkipped(index, skippedRows)) {
                const skippedRow = (
                    <SkippedRow
                        key={generateReactKey(index)}
                        row={row}
                        lastSelectedItem={lastSelectedItem}
                    />
                );
                if (notIncludedInScore(last(row).index, lastSelectedItem)) {
                    notReadWords.push(skippedRow);
                } else {
                    readWords.push(skippedRow);
                }
            } else {
                row.forEach((wordObject, rowIndex) => {
                    const word = (
                        <OralReadingWord
                            key={generateReactKey(index, rowIndex)}
                            word={wordObject.word}
                            isSelfCorrected={selfCorrectedItems.includes(wordObject.index)}
                            isIncorrect={incorrectItems.includes(wordObject.index)}
                            isLastSelected={lastSelectedItem === wordObject.index}
                            notIncludedInScore={notIncludedInScore(
                                wordObject.index,
                                lastSelectedItem,
                            )}
                            selfCorrectedMark={selfCorrectedMark}
                        />
                    );
                    if (notIncludedInScore(wordObject.index, lastSelectedItem)) {
                        notReadWords.push(word);
                    } else {
                        readWords.push(word);
                    }
                });
            }
        });
        const lastWordInParagraph = last(last(paragraph).row);

        if (notIncludedInScore(lastWordInParagraph.index, lastSelectedItem)) {
            notReadWords.push(<br key={generateReactKey(lastWordInParagraph.index)} />);
        } else {
            readWords.push(<br key={generateReactKey(lastWordInParagraph.index)} />);
        }
    });

    return (
        <>
            <span className="bold">{readWords.map(readWord => readWord)}</span>
            {notReadWords.map(notReadWord => notReadWord)}
        </>
    );
};

OralReadingContent.defaultProps = {
    paragraphs: [],
    selfCorrectedMark: 'sc',
};

OralReadingContent.propTypes = {
    itemLevelDetails: PropTypes.object.isRequired,
    paragraphs: PropTypes.array,
    selfCorrectedMark: PropTypes.string,
};

export default OralReadingContent;
